import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import type { RecommendedArticlesBlockProps } from '../interfaces';
import ArticleItem from './ArticleItem';

const RecommendedArticlesBlock = ({
  config,
  recommendedArticles,
}: RecommendedArticlesBlockProps) => {
  const { Track, trackEvent } = useEventTracking({
    ...(config?.analytics_location ? { location: config.analytics_location } : {}),
  });

  return (
    <article className="recommended-articles-block mt-64 sm:mt-96 md:mt-112">
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          if (config?.impression_tracking) {
            inView &&
              trackEvent(impression({ impressionElement: ImpressionElement.MostPopularArticles }));
          }
        }}
      >
        <header>
          <h2 className="m-0 text-center font-suisse-works text-headline-xs sm:text-headline-md lg:text-headline-lg">
            Most Popular Articles
          </h2>
        </header>
        <div className="mt-32 flex flex-col justify-center sm:mt-48 sm:flex-row sm:flex-wrap sm:gap-48 lg:flex-nowrap">
          <Track>
            {recommendedArticles.map((article) => (
              <ArticleItem key={article.id} article={article} />
            ))}
          </Track>
        </div>
      </InView>
    </article>
  );
};

export default RecommendedArticlesBlock;
